import Button from "@mui/material/Button";
import React, { useEffect, useRef, useState } from "react";

const LS_NAME = 'audioMessageRate';
const AUDIO_RATES = [0.5, 1, 1.5, 2];

const getInitialRate = () => {
    const storedRate = parseFloat(localStorage.getItem(LS_NAME) || "1");

    if (!AUDIO_RATES.includes(storedRate)) {
        return 1;
    }

    return storedRate;
};

const formatAudioRate = (rate) => {
    const hasDecimal = rate % 1 !== 0;

    return `${new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: hasDecimal ? 1 : 0,
        maximumFractionDigits: 1,
    }).format(rate)}x`;
};

export default function ({ url }) {
    const audioRef = useRef(null);
    const [audioRate, setAudioRate] = useState(getInitialRate);
    const [showButtonRate, setShowButtonRate] = useState(false);

    useEffect(() => {
        if (!audioRef.current) {
            return;
        }

        audioRef.current.playbackRate = audioRate;
        localStorage.setItem(LS_NAME, audioRate);
    }, [audioRate]);

    useEffect(() => {
        if (!audioRef.current) {
            return;
        }

        audioRef.current.onplaying = () => {
            setShowButtonRate(true);
        };
        audioRef.current.onpause = () => {
            setShowButtonRate(false);
        };
        audioRef.current.onended = () => {
            setShowButtonRate(false);
        };
    }, []);

    const toggleRate = () => {
        const currentIndex = AUDIO_RATES.indexOf(audioRate);
        const nextIndex = currentIndex === -1 || currentIndex === AUDIO_RATES.length - 1
            ? 0
            : currentIndex + 1;

        setAudioRate(AUDIO_RATES[nextIndex]);
    };

    return (
        <div style={{ width: "clamp(220px, 34vw, 320px)", maxWidth: "100%" }}>
            <audio
                ref={audioRef}
                controls
                style={{
                    width: "100%",
                    display: "block"
                }}
            >
                <source src={url}></source>
            </audio>
            {showButtonRate && (
                <Button
                    size="small"
                    variant="outlined"
                    onClick={toggleRate}
                    style={{
                        marginTop: "6px",
                        minWidth: "auto",
                        textTransform: "none",
                        borderRadius: "12px",
                        lineHeight: 1,
                    }}
                >
                    {formatAudioRate(audioRate)}
                </Button>
            )}
        </div>
    );
}
